import { IoCheckmarkCircle, IoAlertCircleOutline } from 'react-icons/io5';
import GeneratedDocumentTab from './generatedDocumentTab';
import DrawingDocumentSection from './drawingDocumentSection';
import StandardsAssessmentSection from './standardsAssessmentSection';
import { generateTechnicalDocumentationPdf, downloadTechnicalDocumentationGeneration, deleteTechnicalDocumentationGeneration } from '../../../../store/actions/packagingUnit';
import { BASE_LANGUAGE, getMarketLanguages } from '../../../../utils/constants/marketLanguages';

const TechnicalDocumentationTab = ({ unit, description }) => {
    const isComplete = !!unit.technicalDocumentationStatus?.current;
    const languageOptions = [BASE_LANGUAGE, ...getMarketLanguages(unit.marketCountries)];

    return (
        <div>
            <div
                className="d-flex align-items-center gap-3 mb-3"
                style={{
                    backgroundColor: isComplete ? '#E6F4EA' : '#FBEBD8',
                    border: `1px solid ${isComplete ? '#8FCBA6' : '#C97D2C'}`,
                    borderRadius: 12,
                    padding: '14px 18px',
                }}
            >
                {isComplete
                    ? <IoCheckmarkCircle size={28} style={{ color: '#198754', flexShrink: 0 }} />
                    : <IoAlertCircleOutline size={28} style={{ color: '#C97D2C', flexShrink: 0 }} />}
                <div style={{ fontSize: 15, fontWeight: 700, color: isComplete ? '#198754' : '#C97D2C' }}>
                    Technická dokumentácia: {isComplete ? 'Splnená' : 'Nesplnená'}
                </div>
            </div>

            <GeneratedDocumentTab
                unit={unit}
                description={description}
                note="Na vygenerovanie je potrebné mať splnené posúdenie zhody a vyplnenú sekciu d) nižšie."
                statusField="technicalDocumentationStatus"
                generateAction={generateTechnicalDocumentationPdf}
                downloadAction={downloadTechnicalDocumentationGeneration}
                deleteAction={deleteTechnicalDocumentationGeneration}
                generateLabel="Vygenerovať technickú dokumentáciu"
                generatingLabel="Generuje sa..."
                emptyText="Zatiaľ nebola vygenerovaná žiadna technická dokumentácia."
                languageOptions={languageOptions}
                requireStandardsAssessment
            >
                <DrawingDocumentSection unit={unit} />
                <StandardsAssessmentSection unit={unit} />
            </GeneratedDocumentTab>
        </div>
    );
};

export default TechnicalDocumentationTab;
